"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var KeyboardBaffirmOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M94.216 636.246l230.259-230.259v187.525h372.034c41.326 0 76.418-14.479 105.376-43.437a142.78 142.78 0 0043.437-104.873c0-41.226-14.378-76.217-43.236-105.075a142.982 142.982 0 00-104.974-43.236h-82.048v-84.864h82.048c64.453 0 119.453 22.724 164.902 68.273 45.549 45.448 68.374 100.45 68.374 164.902 0 64.552-22.926 119.453-68.575 164.901a225.533 225.533 0 01-165.204 68.374H324.475v188.028L94.215 636.246z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
KeyboardBaffirmOutlined.displayName = "KeyboardBaffirmOutlined";
var _default = exports["default"] = KeyboardBaffirmOutlined;